var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{staticClass:"datarow",attrs:{"data-key":_vm.key}})}
var staticRenderFns = []

export { render, staticRenderFns }